import CONSTANTS from '../config';

// Fetch store settings
export async function fetchStoreSettings(storeId = 1) {
  const res = await fetch(`${CONSTANTS.BACKEND_BASE_URL}/api/store/${storeId}`);
  if (!res.ok) throw new Error('Error fetching store settings: ' + res.statusText);
  return res.json();
}

// Create a new order
export async function createOrder({ shippingCost, totalAmount, orderItems }) {
  const res = await fetch(`${CONSTANTS.BACKEND_BASE_URL}/api/orders`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ shippingCost, totalAmount, Order_Items: orderItems }),
  });
  if (!res.ok) throw new Error('Error creating order: ' + res.statusText);
  return res.json();
}

// Patch an existing order
export async function patchOrder(orderData) {
  const res = await fetch(`${CONSTANTS.BACKEND_BASE_URL}/api/orders`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(orderData),
  });
  if (!res.ok) throw new Error('Error updating order: ' + res.statusText);
  return res.json();
}

// Initiate Webpay transaction
export async function createWebpayTransaction({ buyOrder, amount }) {
  const res = await fetch(`${CONSTANTS.BACKEND_BASE_URL}/api/webpay/new`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ params: { buyOrder, amount } }),
  });
  if (!res.ok) throw new Error('Error creating Webpay transaction: ' + res.statusText);
  return res.json();
}

// Initiate Binance transaction
export async function createBinanceTransaction({ orderId, orderAmount }) {
  const res = await fetch(`${CONSTANTS.BACKEND_BASE_URL}/api/binance`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ orderId, orderAmount }),
  });
  if (!res.ok) throw new Error('Error creating Binance transaction: ' + res.statusText);
  return res.json();
}
/**
 * Aplica un código de descuento a una orden usando fetch nativo.
 * @param {string|number} orderId 
 * @param {string} code 
 * @returns {Promise<{ id: number, name: string, discount: number }>}
 */
export async function applyDiscountCode(orderId, code) {
  const res = await fetch(`${CONSTANTS.BACKEND_BASE_URL}/api/orders/${orderId}/discount`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code }),
  });

  if (!res.ok) {
    const error = await res.json().catch(() => null);
    throw new Error(error?.message || `Error ${res.status}`);
  }

  return await res.json();
}